console.log('✅ home-page-featured-categories.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';
import { getTextTranslationByKey } from '../../js/translator.js';
import { getLinksTranslationByKey } from '../../js/router-routes-manager.js';
import { saveToLocalStorage, loadFromLocalStorage } from '../../js/utils-local-storage.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { buildComponentCategoryCard } from '../cards/category-card.js';
import {
  isNodeEnvironment,
  myFetchJsonContentFromBuildData,
} from '../../js/utils-fetch-data-json.js';

import { loadTextTranslations } from '../../js/translator.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';

let _tempTextTranslator = null;
export async function initTempTextTranslator(lang) {
  _tempTextTranslator = await loadTextTranslations(lang);
}

let _tempLinksTranslator = null;
export async function initTempLinksTranslator(lang) {
  _tempLinksTranslator = await initLinksTranslator(lang);
}

export async function buildComponentHomePageFeaturedCategories() {
  console.log(
    `🔄 Building Component: HomePageFeaturedCategories - lang: ${appState.SiteLanguageCookie}`
  );

  try {
    await initTempTextTranslator(appState.SiteLanguageCookie);
    await initTempLinksTranslator(appState.SiteLanguageCookie);

    const {
      keyFindManufacturerByCategories: lblFindManufacturerByCategories,
      keyPopularCategories: lblPopularCategories,
      keySeeAll: lblSeeAll,
      keySeeAllCategories: lblSeeAllCategories,
    } = _tempTextTranslator;

    const { keySubcategories: linkSubcategories } = _tempLinksTranslator;

    // Fetch featured categories
    // const featuredCategories = await populateFeaturedCategories(lang);
    const featuredCategoriesHtml = await renderFeaturedCategoriesHtmlStatic();

    // Build the featured categories HTML
    const html = `
            <center>
                <div class="myPageMargins-Wide">
                    <br />
                    <h2 class="HomePageTitle">${lblFindManufacturerByCategories}</h2>
                    <div class="grid-like-table-one-row-two-cells-with-b-align-right">
                        <div class="grid-like-table-one-row-two-cells-with-b-align-right-cell-A">
                            <h3><strong>${lblPopularCategories}</strong></h3>
                        </div>
                        <div class="grid-like-table-one-row-two-cells-with-b-align-right-cell-B">
                            <a class="viewAllHeaderLink" href="${linkSubcategories}">${lblSeeAll}
                                <img src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/arrow-down4.svg" 
                                     width="15" height="15" alt="" class="viewAllHeaderLink-rightArrow-icon">
                            </a>
                        </div>
                    </div>
                    <br />
              </div>
                    <div id="featuredHomePageCategoryContainerDiv" class="FeaturedHomePageCategoryContainer">
                        ${featuredCategoriesHtml}
                    </div>
                    <br /><br />
                    <a href="${linkSubcategories}">${lblSeeAllCategories}</a>
                    <br />
                
                </center>
       
        `;

    console.log('✅ HomePageFeaturedCategories built successfully.');

    // Register event listeners
    //  registerEventListenerToAttach(attachEventListenersHomePageFeaturedCategories);

    registerEventListenerToAttach(async () => attachEventListenersHomePageFeaturedCategories());

    return html;
  } catch (err) {
    console.error('❌ Error building HomePageFeaturedCategories:', err);
    return '<div>Error loading featured categories</div>';
  }
}

async function renderFeaturedCategoriesHtmlStatic() {
  if (isNodeEnvironment()) {
    return await renderFeaturedCategoriesHtml();
  } else {
    return await renderLoadingData();
  }
}

async function renderLoadingData() {
  const countOfItems = 18; // Replace this with your actual value

  const resultCardPromises = [];

  for (let i = 0; i < countOfItems; i++) {
    const name = '';
    const builtLink = '';
    const imageSource = '';
    const categoryCardType = 'Lazy';

    resultCardPromises.push(
      buildComponentCategoryCard(builtLink, imageSource, name, categoryCardType)
    );
  }

  const resultCards = await Promise.all(resultCardPromises);

  return resultCards.join('');
}

async function renderFeaturedCategoriesHtml() {
  console.log('🔄 Rendering featured categories HTML');

  const featuredCategories = await populateFeaturedCategories();

  if (!featuredCategories || featuredCategories.length === 0) {
    return `<p>No featured categories available at the moment.</p>`;
  }

  const catgorycards = await Promise.all(
    featuredCategories.map(async category => {
      const builtLink = `/${appState.SiteLanguageCookie}/${category.defaultDepartmentID}/${category.defaultDepartmentSEOPageName}/${category.categoryID}/${category.seoPageName}`;

      const imageSource = category.image1FileName;
      const name = category.name;
      const categoryCardType = 'Basic';

      return await buildComponentCategoryCard(builtLink, imageSource, name, categoryCardType);
    })
  );

  return catgorycards.join('');
}

async function attachEventListenersHomePageFeaturedCategories() {
  try {
    console.log('✅ HomePageFeaturedCategories event listeners attached.');
    // Placeholder for future event listeners if needed

    const featuredHomePageCategoryContainerDiv = document.getElementById(
      'featuredHomePageCategoryContainerDiv'
    );
    if (!featuredHomePageCategoryContainerDiv) {
      console.error("❌ Element with ID 'featuredHomePageCategoryContainerDiv' not found.");
      return;
    } else {
      let html = await renderFeaturedCategoriesHtml();
      featuredHomePageCategoryContainerDiv.innerHTML = html;
    }
  } catch (error) {
    console.error('❌ Error attaching event listeners to HomePageFeaturedCategories:', error);
  }
}

async function populateFeaturedCategories() {
  console.log('✅ Populating Home Page Featured Categories');

  const storageKey = `homePageFeaturedCategories_${appState.SiteLanguageCookie}`;

  // Try to load from localStorage first
  const cachedCategories = loadFromLocalStorage(storageKey);
  if (cachedCategories && Array.isArray(cachedCategories) && cachedCategories.length > 0) {
    console.log('✅ Loaded HomePageFeaturedCategories from cache');
    return cachedCategories;
  }

  // Fetch from the server if not cached
  console.log('🌐 Fetching HomePageFeaturedCategories from server');
  return await fetchFeaturedCategories();
}

async function fetchFeaturedCategories() {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Fetching featured products from pre-built data');

      const data = await myFetchJsonContentFromBuildData('home-page-featured-categories.json');

      //console.log("Filtered Data:", data);

      if (data && data[appState.SiteLanguageCookie]) {
        const products = data[appState.SiteLanguageCookie];
        console.log(
          `✅ Loaded featured categories for language '${appState.SiteLanguageCookie}' from pre-built data`
        );
        return products;
      } else {
        console.warn(
          `⚠️ No featured categories found for language '${appState.SiteLanguageCookie}'`
        );
        return [];
      }
    } else {
      const storageKey = `homePageFeaturedCategories_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);

      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log('✅ Loaded featured categories from cache');
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetAllFeaturedCategoriesAsync?languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to fetch featured categories from server');

      const featuredCategories = await response.json();

      // Save to localStorage
      saveToLocalStorage(storageKey, featuredCategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log('🌐 Fetched featured categories from the server');
      return featuredCategories;
    }
  } catch (error) {
    console.error('❌ Error fetching home page featured categories:', error);
    return [];
  }
}
